import { render, staticRenderFns } from "./PostEPHandoverInfo.vue?vue&type=template&id=7c72f170"
import script from "./PostEPHandoverInfo.vue?vue&type=script&lang=js"
export * from "./PostEPHandoverInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports